var options = {
  path: '/cep',
  title: ' 编审发',
  icon: 'wpforms',
  hideSub: true,
  children: ((pre) => [
    { path: `${pre}article/update`, title: '新建作品', icon: 'dot-circle-o' },

    { path: `${pre}article`, title: '作品库', icon: 'dot-circle-o' },
    {
      path: `${pre}article/review-list`,
      title: '作品审核',
      icon: 'dot-circle-o'
    },

    // {
    //   title: '媒体多元发布',
    //   icon: 'globe',
    //   children: [
    //     { path: `http://gj.gsdata.cn/materialCenter`, title: '图文多元发布', icon: 'dot-circle-o' },
    //     { path: `/cep/article/new`, title: '视频', icon: 'dot-circle-o' },
    //     { path: `/media/index`, title: '新闻网配置', icon: 'dot-circle-o' }
    //   ]
    // },

    {
      path: `${pre}insight`,
      title: '发布管理',
      icon: 'globe',
      children: [
        { path: `${pre}publish`, title: '发布审核', icon: 'dot-circle-o' },
        { path: `${pre}publish/history`, title: '发布记录', icon: 'dot-circle-o' }
      ]
    },
    
    { path: `${pre}article/my-submit`, title: '投稿管理', icon: 'dot-circle-o' },

    { path: `${pre}article/wx`, title: '微信组稿发布', icon: 'dot-circle-o' },
    // { path: `${pre}cloudEditor`, title: '云编辑', icon: 'dot-circle-o' },


    {
      title: '云编辑',
      icon: 'dot-circle-o',
      children: [
        { path: `${pre}cloudEditor`, title: '云编辑', icon: 'dot-circle-o' },
        { path: `${pre}videoAudit`, title: '视频审核', icon: 'dot-circle-o' },
        { path: `${pre}contentAyalysis`, title: '内容分析', icon: 'dot-circle-o' }
      ]
    },


    // {
    //   path: `${pre}insight`,
    //   title: '选题策划',
    //   icon: 'globe',
    //   children: [
    //     { path: `${pre}insight/hot`, title: '热点事件', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/top`, title: '热点新闻', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/monitor`, title: '热点方案', icon: 'dot-circle-o' }
    //   ]
    // },
    // { path: `${pre}bookmark`, title: '我的收藏', icon: 'bookmark-o' }
  ])('/cep/')
}

export default options
